import React from "react";

// Local
import CountryDot from "./CountryDot";
import { BoxRow, Label } from "../../styled/styled";

const LegendItem = ({ label, fill, stroke, strokeWidth }) => {
  const radius = 5;

  return (
    <BoxRow style={{ alignItems: "baseline" }}>
      <svg width={radius * 2} height={radius * 2}>
        <CountryDot
          r={radius - 1}
          cx={radius}
          cy={radius}
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </svg>
      <Label>
        <small>{label}</small>
      </Label>
    </BoxRow>
  );
};

export default LegendItem;
